import React from "react";

function OurResponsibility() {
  return (
    <>   <div className="mt-[4.5rem] border-t border-gray-300"></div>
    <div className="mt-[4rem] flex items-center justify-center p-2 mb-[4rem]">
      <div className="max-w-3xl w-full">
        {/* Heading - Center */}
        <h1 className="text-xl md:text-3xl letterSpacing text-center mb-12">
          OUR RESPONSIBILTY
        </h1>

        {/* Description - Left aligned, all lines start from same point */}
        <div className=" leading-relaxed   text-center">
          <p className="mb-6 text-center text-[2rem]">#WEARHAPPINESSTHISEID</p>

          <p className="mb-6 border-t  border-gray-300 pt-4 pb-4">
            Eid is a celebration of love. What better way than giving back the
            love to the ones who deserve the most. Mothers, more than anybody
            else, are worthy of love. A mother puts her children before anything
            else without expecting anything in return. This Eid, Let's put
            Mothers first and bring light in her life by keeping her happy and
            comfortable at all times. Baroque celebrates, appreciates and honors
            all strong mothers out there. Here's to strong women. May we know
            them. May we be them. May we raise them!
          </p>

          <p className="mb-6 border-t  border-gray-300 pt-6 pb-4">
            We remembered those who put together all the effort to make our Eid
            special. We made them a part of our Eid and gave them the happiness
            they deserve to wear. Just like last year, our aim was to make them
            wear happiness and the joy that we experienced on their faces is
            what we were looking for.
          </p>

          <p className="mb-6  border-t border-b border-gray-300 pt-4 pb-4">
            We initiated our purpose to work as a part of something good so we
            decided to surprise these children by bringing them Eidi. We felt
            extremely joyous to make custom suits for these beautiful children
            and mothers from SOS children’s village. Giving back to our society
            is one of our major responsibilities but it was more than that... it
            was a beautiful experience.
          </p>
        </div>
      </div>
    </div>

     </>
      );
}

export default OurResponsibility;
